import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../context/AppContext";

const Doctors = () => {
  const speci = [
    "General physician",
    "Gynecologist",
    "Dermatologist",
    "Pediatricians",
    "Neurologist",
    "Gastroenterologist",
    "doctors"
  ];
  const { speciality } = useParams();
  const { doctors } = useContext(AppContext);
  const navigator = useNavigate();
  const [filterdData, filtring] = useState([]);
  const applyFilter = () => {
    if (speciality) {
      filtring(doctors.filter((doc) => doc.speciality === speciality));
    } else {
      filtring(doctors);
    }
  };
  useEffect(() => {
    applyFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [doctors, speciality]);
  return (
    <div className="  ">
      <div className=" flex gap-1 justify-center  flex-wrap  ">

        {speci.map((ele, index) => (
          <p
            onClick={() => {
              navigator(`/doctors/${ele==="doctors"?"":ele}`);
            }}
            className={`border cursor-pointer  rounded-xl shadow-md px-4 py-2 ${speciality === ele? "bg-primary text-white text-lg":"" }`}
            key={index}
          >
            {ele}
          </p>
        ))}
        
      </div>
      <div className=" flex  pt-5 px-3 sm:px-0 gap-4 justify-center flex-wrap ">
        {filterdData.map((ele, index) => (
          <div
            className=" border w-60 border-blue-200 rounded-xl  cursor-pointer"
            key={index}
            onClick={() => navigator(`/appointment/${ele._id}`)}
          >
            <img className="bg-blue-50" src={ele.image} alt="ele" />
            <div className="p-2">
              <div className="flex gap-1 items-center mt-2">
                <p className="h-3 bg-green-500 rounded-full w-3 "></p>
                <p>Available</p>
              </div>
              <p className="text-lg font-medium text-gray-900">{ele.name}</p>
              <p className="text-sm text-gray-500 ">{ele.speciality}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Doctors;
